<script>
  import DatePicker from '@sum.cumo/vue-datepicker'
  import {
    generateId,
  } from '../plugins/utils.js'
  import { 
    CalendarIcon 
  } from 'vue-feather-icons'

  const CALENDAR_SIZE= 375;
  
  export default {
    name: 'FabricDatePicker',
    components:{
      CalendarIcon,
      DatePicker,
    },
    model: {
      prop: 'modelValue',
      event: 'update'
    },
    props: {
      modelValue: {
        type: String,
        required: true,
      },
      id: {
        type: [String, Number],
        default: (() => generateId()),
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isOpen: false,
        justClosed: false,
        timestamp: Date.now(),
      }
    },
    computed: {
      antiClassPurge(){
        return [
          'before:tw-translate-x-[19px]',
        ]
      }
    },
    methods:{
      toggleChange(event){
        // just grab date
        const asString = event.toISOString().split('T')[0]
        this.$emit('update', asString)
      },
      handleClick(event){
        if (this.disabled || this.justClosed){
          return
        }
        // should scroll
        if(!this.isOpen && this.$refs.datePicker.$el.getBoundingClientRect().y + CALENDAR_SIZE > window.innerHeight){
          const scrollAmount = this.$refs.datePicker.$el.getBoundingClientRect().y + CALENDAR_SIZE - window.innerHeight;
          document.getElementById('scroll-root').scrollBy({
            top: scrollAmount,
            behavior: 'smooth'
          });
        }

        this.timestamp = Date.now()
        // only toggle isOpen if currently closed
        // preserve close toggle to be wrapped by the `@close` emit
        if (!this.isOpen){
          this.isOpen = !this.isOpen
        }
        setTimeout(() => {
          this.$nextTick(() => {
            if (this.$refs && this.$refs.datePicker){
              if (this.isOpen){
                this.$refs.datePicker.resetFocusToOpenDate()
              }else{
                this.$refs.datePicker.close()
              }
            }
          })
        }, 250);
      },
      toggleClose(){
        this.isOpen = false
        this.justClosed = true
        setTimeout(() => {
          this.justClosed = false
        }, 100)
      }
    }
  }
</script>

<template>
  <section
    :id="id + '__fb_datePicker__'"
    class="tw-flex tw-flex-row tw-items-center">
    <article 
      :class="[
        'tw-w-11 tw-h-full',
        'tw-inline-block',
        'tw-relative',
        'tw-bg-gray-500',
        {
          'tw-cursor-pointer  hover:tw-bg-primary': !disabled,
          'tw-bg-opacity-50': disabled,
        },
      ]"
      @click="handleClick($event)">
      <DatePicker
        ref='datePicker'
        :key="timestamp"
        use-utc
        :disabled="disabled"
        :value="modelValue"
        :append-to-body="false"
        :fixed-position="'bottom-right'"
        @input="toggleChange"
        @closed="toggleClose"/>
      <span 
        class="
          tw-absolute tw-right-0 tw-top-0
          tw-flex tw-items-center tw-justify-center 
          tw-h-full tw-w-full 
        ">
        <CalendarIcon size="1.5x" class="tw-text-white"/>
      </span>
    </article>
  </section>
</template>

<style>
  @import '~@sum.cumo/vue-datepicker/dist/Datepicker.css';
</style>